import React from 'react'
import common from './methods/common.js'
import CONSTANTS from './CONSTANTS.js'
// import userJpg from "./assets/img/vacspl/user.jpeg"

const ReportingSheets = () => {

    const excludeArr = ["Director", "Powder", "Service", "Equipment"]
    const {SHEETS} = CONSTANTS
    const {ALL_SERVICE_RECORD_SHEET} = SHEETS

    let directors = common.getUsers().filter(user=>user.department==="Director")
    let powder = common.getUsers().filter(user=>user.department==="Powder")
    let service = common.getUsers().filter(user=>user.department==="Service")
    let equipment = common.getUsers().filter(user=>user.department==="Equipment")
    let others = common.getUsers().filter(user=>!excludeArr.includes(user.department))

    // let service_list = 


    const renderGroup=(userArr)=> (
        <div className='user-main'>
            {userArr.map(user => (
                <div className='user-card'>
                    <div>Name: <strong>{user.first_name} {user.last_name}</strong></div>
                    {/* <div>Disugnation: <strong>{user.first_name}</strong></div> */}
                    <div>Department: <strong>{user.department}</strong></div>
                    <div>Service Report Access: <strong>{user.Is_service_access ? "Yes" : "No"}</strong></div>
                    <div>Gun Quotation Access: <strong>{user.Is_gun_quotation_access ? "Yes" : "No"}</strong></div>
                    {user.sheet_url?<div className='action'><button className='button-3' onClick={()=>window.open(user.sheet_url, "_blank")}>View Sheet</button></div>:null}
                    {user.sheet_output?<div className='action'><button className='button-3' onClick={()=>window.open(user.sheet_output, "_blank")}>Sheet Analysis Proto</button></div>:null}
                </div>
            ))}
        </div>
    )


    return (
        <div className='user-page'>
            <div className='heading-user'>Directors</div>
            {renderGroup(directors)}

            <hr class="solid"></hr>
            <div className='heading-user'>All Service Records </div>
            <div className='user-main'>
                <div className='user-card'>
                    <div>All Service Records</div>
                    <div className='action'><button className='button-3' onClick={() => window.open(ALL_SERVICE_RECORD_SHEET, "_blank")}>View Sheet</button></div>
                </div>
            </div>

            <hr class="solid"></hr>
            <div className='heading-user'>Equipment</div>
            {renderGroup(equipment)}

            <hr class="solid"></hr>
            <div className='heading-user'>Powder</div>
            {renderGroup(powder)}

            <hr class="solid"></hr>
            <div className='heading-user'>Service</div>
            {renderGroup(service)}

            <hr class="solid"></hr>
            <div className='heading-user'>Others</div>
            {renderGroup(others)}
            
        </div>
    )
}

export default ReportingSheets